import { useEffect, useState } from 'react';
import bookingApi from '../../lib/api/booking';
import { useParams } from 'react-router-dom';
import { Booking } from '../../types/booking';
import Payment from '../../components/payment';
import BookingSummary from '../../components/booking-summary';
import { modulbankId, modulbankSuccessUrl, modulbankTest, routes, tapPaymentPubKey } from '../../config/constants';
import PaymentModulbank from '../../components/paymentModul';
import { useLocalizationContext } from '../../contexts/localizationContext';
import TapPayment from '../../components/payment/tap-payment';
import { useQuery } from '../../hooks/use-query';
import { captureClickIds } from '../../lib/click-ids';

type Props = {
  ru?: boolean;
  tapPayment?: boolean;
};
const Main = ({ ru, tapPayment }: Props) => {
  const { setLanguage, currency, setCurrency } = useLocalizationContext();
  const params = useParams();
  const query = useQuery();

  useEffect(() => {
    if (ru) {
      setLanguage('ru');
      setCurrency('rub');
    }
  }, [ru, setCurrency, setLanguage]);
  const [booking, setBooking] = useState<Booking>();

  useEffect(() => {
    // Best-effort Google Ads click-id capture; only finds cookies on brand-domain paypages.
    // Skipped on the RU route: that flow is Yandex-market and never uploads to Google Ads.
    !ru && params.guid && captureClickIds(params.guid);
  }, [ru, params.guid]);

  useEffect(() => {
    const getBooking = async () => {
      const data = params.guid && (await bookingApi.getBooking(params.guid, ru ? 'rub' : currency));
      data && setBooking(data);
    };
    getBooking();
  }, [currency, params.guid, ru]);

  const tapPaymentForm = booking && (
    <TapPayment
      bookingGuid={booking.guid}
      paymentIntent={booking.paymentIntent}
      amount={booking.totalPayable}
      guestName={booking.guestName}
      email={booking.email}
      phone={booking.phone}
    />
  );

  return booking ? (
    <div className="container">
      <BookingSummary booking={booking} />
      {booking.isPayable ? (
        ru ? (
          <PaymentModulbank
            amount={booking.totalPayable}
            amountUsd={booking.totalPayableUsd}
            convRate={booking.convRate}
            booking={booking}
            isValid={true}
            ticketType={booking.offerName}
            modulbankId={modulbankId || ''}
            modulbankSuccessUrl={modulbankSuccessUrl || ''}
            modulbankTest={modulbankTest}
            legalInfoPaymentProcessUrl={routes.legalInfoRoutes.paymentProcess}
          />
        ) : tapPayment && tapPaymentPubKey ? (
          query.get('tap_id') && !booking.paymentErrorMessage ? (
            <>Please wait, payment is being processed</>
          ) : (
            <>
              {query.get('tap_id') && booking.paymentErrorMessage}
              {tapPaymentForm}
            </>
          )
        ) : (
          <Payment bookingGuid={booking.guid} paymentIntent={booking.paymentIntent} amount={booking.totalPayable} />
        )
      ) : (
        !!booking.notPayableDescription?.length && (
          <div className="panel">
            {booking.notPayableDescription?.map((item) => (
              <div>{item}</div>
            ))}
          </div>
        )
      )}
      {/*<Accordeon items={faq} />*/}
    </div>
  ) : null;
};

export default Main;
